import React from 'react';
import { Helmet as HelmetComponent } from 'react-helmet';
import { defineMessages, useIntl } from 'react-intl';
const DEFAULT_LANG = 'en';
const DEFAULT_TITLE = 'polaris';
// react-helmet@6.1 + @types/react>=18 の JSX 型不整合を回避(既知問題)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Helmet = HelmetComponent;
const msgs = defineMessages({
    metaDescription: {
        id: 'nav.Head.meta.description',
        defaultMessage: 'polaris',
    },
});
function Head({ lang = DEFAULT_LANG, title, description, twitterUsername, imageUrl }) {
    const intl = useIntl();
    const locale = intl.locale;
    const url = window?.location.href || 'unknown';
    const desc = description ? description : intl.formatMessage(msgs.metaDescription);
    return (React.createElement(Helmet, { title: title, defaultTitle: DEFAULT_TITLE, titleTemplate: 'polaris | %s', htmlAttributes: { lang } },
        React.createElement("link", { rel: "icon", href: "data:," }),
        React.createElement("meta", { name: "description", content: desc }),
        imageUrl ? React.createElement("meta", { name: "image", content: imageUrl }) : null,
        React.createElement("meta", { property: "og:url", content: url }),
        React.createElement("meta", { property: "og:type", content: "website" }),
        React.createElement("meta", { property: "og:title", content: title }),
        React.createElement("meta", { property: "og:site_name", content: DEFAULT_TITLE }),
        React.createElement("meta", { property: "og:description", content: desc }),
        React.createElement("meta", { property: "og:locale", content: locale }),
        imageUrl ? React.createElement("meta", { property: "og:image", content: imageUrl }) : null,
        React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
        React.createElement("meta", { name: "twitter:title", content: title }),
        React.createElement("meta", { name: "twitter:description", content: desc }),
        twitterUsername ? React.createElement("meta", { name: "twitter:creator", content: twitterUsername }) : null,
        imageUrl ? React.createElement("meta", { name: "twitter:image", content: imageUrl }) : null));
}
export default React.memo(Head);
